export default __webpack_public_path__ + "static/media/icon-delete.8e2c6e34.svg";